export const environment = {
    production: false,
    api_url: 'https://api.devmonagil.fr',
    app_url: 'https://app.devmonagil.fr',
    vitrine_url: 'https://devmonagil.fr',
    stripe_key: 'pk_test_51GtCq2KXMSnQ7TAEi2Mx7XeQUzlggD7isdzllDed1WeYM0Am6xXWt4O9AaAAtw95NCSa4s0EUsmKuvgwNCPl0mNi00kzC3CBI4'
};